import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { SUPPORT_WHATSAPP_URL } from '../constants';

const PREFILL = 'Hi GoSnel — Local Partner support';

export default function LpWhatsAppFab() {
  const href = `${SUPPORT_WHATSAPP_URL}?text=${encodeURIComponent(PREFILL)}`;

  return (
    <Tooltip title="WhatsApp support" placement="left">
      <Fab
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        color="success"
        size="medium"
        aria-label="WhatsApp support"
        sx={{
          position: 'fixed',
          right: { xs: 16, sm: 24 },
          bottom: { xs: 72, sm: 80 },
          zIndex: 1050,
          bgcolor: '#25D366',
          color: '#fff',
          '&:hover': { bgcolor: '#1ebe57' },
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  );
}
